module.exports = __webpack_public_path__ + "img/intro-mobile-fr.f48e2945.jpg";